import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RefillsDialogData, SingleOrMultiRequestNotes } from 'src/app/requests-results/models/request.interface';
import { RequestService } from 'src/app/requests-results/services/request.service';
import { LineItem } from 'src/app/line-item-entry/models/line-item.interface';

@Component({
  selector: 'app-refills-dialog',
  templateUrl: './refills.dialog.html',
  styleUrls: ['./refills.dialog.scss']
})
export class RefillsDialogComponent implements OnInit {
  model: LineItem;
  canSubmit = false;
  isEditable: boolean;
  isEdited = false;

  constructor(
    public dialogRef: MatDialogRef<RefillsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RefillsDialogData,
    public requestService: RequestService,
    public snackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.isEditable = this.data.IsEditable;
    this.model = JSON.parse(JSON.stringify(this.data.LineItem));
  }

  save() {
    this.isEdited = true;
    const dialogReturnValue = this.isEdited ? this.model : undefined;
    this.dialogRef.close(dialogReturnValue);
  }

  cancel() {
    this.dialogRef.close();
  }

  validate(isValid: boolean) {
    this.canSubmit = isValid;
  }

  onNotesChanged(newNotes: SingleOrMultiRequestNotes) {
    this.isEdited = true;

    if (this.model.lineItemRequest == null) {
      return;
    }

    if (typeof newNotes === 'string') {
      this.model.lineItemRequest.singleRequestNote = newNotes;
    } else {
      this.model.lineItemRequest.multiRequestNotes = newNotes;
    }
  }
}
